import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import SignaturePad from 'react-signature-pad-wrapper';
import { TextField } from '@material-ui/core';
import './CustomerSignatureSection.css';
import { intlText } from '../../../../../utils/text-util';
import { injectIntl } from 'react-intl';
import { Button } from '@material-ui/core';
import { getRegionalColors } from '../../../../../utils/regional-colors';

class CustomerSignatureSection extends PureComponent {
  constructor(props) {
    super(props);

    this.signatureBox = null;
    this.onSignatureBoxLoad = this.onSignatureBoxLoad.bind(this);
    this.signatureBoxRef = this.onSignatureBoxLoad;
    this.onSignatureChange = this.onSignatureChange.bind(this);
    this.clearSignature = this.clearSignature.bind(this);
  }

  onSignatureChange(event) {
    this.props.onSignatureChange(this.signatureBox.toDataURL());
  }

  onSignatureBoxLoad(box) {
    if (!box) {
      return;
    }
    this.signatureBox = box;

    this.signatureBox.signaturePad.addEventListener("endStroke", () => this.onSignatureChange())

    if (!!this.props.signatureImage) {
      this.signatureBox.fromDataURL(this.props.signatureImage);
    }
    if (!this.props.enabled) {
      this.signatureBox.off();
    }
  }

  componentWillUnmount() {
    if (!!this.signatureBox && !!this.signatureBox.signaturePad) {
      this.signatureBox.signaturePad.removeEventListener("endStroke");
    }
  }

  isValid(fieldName) {
    return !this.props.invalidFields.includes(fieldName);
  }

  getValidityClassName(fieldName) {
    return this.isValid(fieldName) ? '' : 'invalid-field';
  }

  clearSignature() {
    this.signatureBox.clear();
    this.props.onSignatureChange(null);
  }

  render() {
    return (
      <div>
        {!this.props.hideTermsNotice ? (
          <section>
            <div>
              {intlText(this.props, 'service_promise_paragraph_part_2')}
            </div>
          </section>
        ) : null}
        <div className="row signature-section">
          <div className="signature-section-left-box col-xs-12 col-md-6 m-b-15">
            <label
              style={{fontWeight:'bolder'}}
              htmlFor="signature-pad-area">
              {intlText(this.props, 'approver_signature')}
            </label>
            <div id="signature-pad-area">
              <SignaturePad
                className={`signature-pad ${this.getValidityClassName(
                  'signatureImage'
                )}`}
                redrawOnResize
                ref={this.signatureBoxRef}
              />
            </div>
            <Button
              classes={{
                root: 'clear-signature-button',
                disabled: 'clear-signature-button-disabled'
              }}
              onClick={this.clearSignature}
              disabled={!this.signatureBox || this.signatureBox.isEmpty()}
            >
              {intlText(this.props, 'clear')}
            </Button>
          </div>
          <div className="signature-section-right-box col-xs-12 col-md-6 m-b-15">
            <div className={`customer-signature-element-wrapper`}>
              <label
                style={{fontWeight:'bolder'}}
                htmlFor="full-name-text-box">
                {intlText(this.props, 'approver_full_name')}
              </label>
              <TextField
                id="full-name-text-box"
                placeholder={intlText(
                  this.props,
                  'signature_full_name_placeholder'
                )}
                fullWidth
                className={
                  this.isValid('fullName')
                    ? 'customer-detail-input'
                    : 'customer-detail-input-invalid'
                }
                value={this.props.fullName}
                onChange={(event) =>
                  this.props.onFullNameChange(event.target.value)
                }
                disabled={!this.props.enabled}
              />
            </div>
            <div className={`customer-signature-element-wrapper`}>
              <label
                style={{fontWeight:'bolder'}}
                htmlFor="email-text-box">
                {intlText(this.props, 'approver_email')}
              </label>
              <TextField
                id="email-text-box"
                placeholder={intlText(
                  this.props,
                  'signature_email_address_placeholder'
                )}
                fullWidth
                className={
                  this.isValid('email')
                    ? 'customer-detail-input'
                    : 'customer-detail-input-invalid'
                }
                value={this.props.email}
                onChange={(event) =>
                  this.props.onEmailChange(event.target.value)
                }
                disabled={!this.props.enabled}
              />
            </div>
          </div>
        </div>
        <div>{intlText(this.props, 'signature_promise')}</div>
      </div>
    );
  }
}

CustomerSignatureSection.propTypes = {
  signatureImage: PropTypes.string.isRequired,
  fullName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  onSignatureChange: PropTypes.func,
  onFullNameChange: PropTypes.func,
  onEmailChange: PropTypes.func,
  invalidFields: PropTypes.array.isRequired,
  hideTermsNotice: PropTypes.bool,
  languageCode: PropTypes.string.isRequired
};

export default injectIntl(CustomerSignatureSection);
